import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TrendType } from './trend-type';

@Component({
    selector: 'ca-trend-badge',
    templateUrl: './trend-badge.component.html',
    styleUrls: ['./trend-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TrendBadgeComponent {
    public trend = input.required<TrendType>();
    public value = input<number>();
    protected icon = computed(() => this.getIcon(this.trend()));
    protected displayedValue = computed(() => this.getDisplayedValue(this.value()));

    private getIcon(trendType: TrendType): string {
        const iconMap: { [key in TrendType]: string } = {
            positive: 'arrow-up',
            neutral: 'arrow-down',
            negative: 'arrow-right'
        };

        return iconMap[trendType];
    }

    private getDisplayedValue(value: number | undefined): string | number {
        if (value === undefined) return '-';
        const absValue = Math.abs(value);
        const displayedValue = absValue >= 1000 ? 999 : absValue;
        if (value > 0) return `+${displayedValue}`;
        else if (value < 0) return `-${displayedValue}`;
        return displayedValue;
    }
}
